export default "__VITE_ASSET__BxEjzhos__"